import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

import * as Sentry from "@sentry/capacitor";
import * as SentryReact from "@sentry/react";

const getEnvironment = (): string => {
  if (import.meta.env.DEV) {
    return "development";
  }
  
  if (globalThis.window !== undefined) {
    const hostname = globalThis.window.location.hostname;
    if (hostname.endsWith(".lovable.app")) {
      return "preview";
    }
  }
  
  return "production";
};

Sentry.init(
  {
    dsn: "https://fdcd8253f03cb38a9f3f7772ec0554c9@o4510758613483520.ingest.de.sentry.io/4510758640484432",
    sendDefaultPii: true,
    environment: getEnvironment(),
    release: "prsnl-app@0.1.0",
    dist: "1",
  },
  SentryReact.init
);

const rootElement = document.getElementById("root");
if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StrictMode>
  );
}
